/*
 * A&K 10.000
 * Author: Rouven Pajewski
 * Company: ActiView GmbH
 *
 * http://www.actiview.de
 */

$(document).ready(function() {
    var $window = $(window);

    function collapseTabs(reset)
    {
        if ($window.width() < 991) {
            $('.tab-info-content-collapse').each(function() {
                if (!reset || !$(this).attr('data-height')) {
                    $(this).attr('data-height', $(this).height() + 10);
                }

                if ($(this).height() > 270) {
                    $(this).attr('data-tab-collapse', true);
                    $(this).css({'height': 270 + 'px'})

                    if (!$(this).closest('.tab-info-wrapper').find('.tab-info-collapse').length) {
                        $(this).after('<div class="btn btn-white btn-small btn-big tab-info-collapse">Text aufklappen</div>');
                    }
                } else {
                    $(this).attr('data-tab-collapse', false);
                }
            });
        } else {
            $('.tab-info-content-collapse').each(function() {
                 $(this).css({'height': 'auto'});
                 $(this).attr('data-tab-collapse', false);
            });
        }
    }

    $('.tab-info-panel-btn').click(function() {
        $(this).closest('.tab-info-content').find('.tab-panel-btn').removeClass('active');
        $(this).addClass('active');
    });

    // Entfernt Plenty-Inlinestyles
    $('.tab-info-content').find('[style]').removeAttr('style');

    $(document).on('click', '.tab-info-collapse', function() {
        var $wrapper = $(this).closest('.tab-info-wrapper');
        if ($wrapper.hasClass('open')) {
            $wrapper.removeClass('open');
            $wrapper.find('.tab-info-content').css({'height': 270 + 'px'});
        } else {
            $wrapper.addClass('open');
            $wrapper.find('.tab-info-content').css({'height': $wrapper.find('.tab-info-content').attr('data-height') + 'px'});
        }
    });

    $window.resize(function() {
        collapseTabs(true);
    });

    collapseTabs(false);
});